import { Card } from '@/components/ui/card'
import OrganizationPricing from './components/organization-pricing'
import { usePlan } from '@/hooks/use-plan'
import { useTranslation } from 'react-i18next'
import { tokens } from '@/locales/translations/tokens';
import { useFormmatedPlanName } from '@/hooks/use-formmated-plan-name';

export default function SelectOrganizationPlan() {
  const { t } = useTranslation();
  const { plan } = usePlan()

  const isUpgrade = !!plan?.type
  const currentPlan = plan?.type
  const formattedPlan = useFormmatedPlanName(currentPlan);

  return (
    <div className='container flex min-h-svh flex-col items-center justify-center bg-primary-foreground px-2 pb-12 sm:px-4 lg:max-w-none lg:px-0'>
      <div className='mx-auto flex w-full max-w-full flex-col justify-center space-y-4 sm:w-[840px] md:w-[900px] lg:w-[1100px] lg:p-8 xl:w-[1200px]'>
        <Card className='mx-0 p-4 shadow-md sm:mx-0 sm:p-6 md:p-8'>
          <div className='mb-6 text-center sm:mb-10'>
            <h1 className='mb-2 text-xl font-semibold tracking-tight sm:mb-3 sm:text-2xl'>
              {isUpgrade 
                ? t(tokens.onboarding.organization_pricing.upgrade_plan)
                : t(tokens.onboarding.organization_pricing.choose_plan_for_organization)}
            </h1>
            <p className='text-xs text-muted-foreground sm:text-sm'>
              {isUpgrade 
                ? t(tokens.onboarding.organization_pricing.current_plan_message, {
                  currentPlan: formattedPlan
                })
                : t(tokens.onboarding.organization_pricing.congratulations_choose_plan)}
            </p>
          </div>

          <OrganizationPricing className='pb-2' />
        </Card>
      </div>
    </div>
  )
}
